import { SurveyPresentationCondition } from "@prisma/client";
import { SurveyOptionsSchema } from "@superwall-me/schema";
export const ReadablePresentationConditions = {
    [SurveyPresentationCondition.ON_MANUAL_CLOSE]: "When the user closes the paywall.",
    [SurveyPresentationCondition.ON_PURCHASE]: "After the user purchases."
};
export const parseSurvey = (survey)=>{
    const options = survey.options ? SurveyOptionsSchema.parse(survey.options) : [];
    return {
        ...survey,
        options
    };
};
